import { useDispatch, useSelector } from "react-redux";
import classes from "./Test.module.css"
import { RootState } from "../../Store/store";
import { useEffect, useMemo, useState } from "react";
import { ILesson } from "../../Intarfaces/ILesson";
import Button1 from "../../Components/UI/Button1/Button1";
import Button2 from "../../Components/UI/Button2/Button2";
import { lastStep } from "../../Store/userSlice";
import { useNavigate } from "react-router-dom";
import Question from "./Question";
import { ITest } from "../../Intarfaces/ITest";
import UserApi from "../../API/UserAPI";
import { IUserEdit } from "../../Intarfaces/IUser";
import FullSpaseLoader from "../../Components/UI/Loader/FullSpaseLoader";

const Test = () => {

    const dispatch = useDispatch()
    const lessons = useSelector((state:RootState)=>state.user.lessons)
    const user = useSelector((state:RootState)=>state.user.user)
    const maxActiveLessonId = useSelector((state:RootState)=>state.user.maxActiveLessonId)
    const test = useSelector((state:RootState)=>state.user.test)
    const nav = useNavigate()

    const [answers, setAnswers] = useState<{[index:number]:number|null}>({
        ...Object.assign({}, [...test.map((it,i )=>null)])
    })
 
    const setValue=(id:number, value:number)=>{
        setAnswers((state)=>{return {  ...state,[id]:value}})
    }

    const [error, setError] = useState('')

    const [isLoader, setIsLoader] = useState(false)
    const setLastStep = async () =>{
        setIsLoader(true)
        const response = await UserApi.edit({...user} as IUserEdit, maxActiveLessonId+1)
        setIsLoader(false)
        if(response.status!==200){
            console.log(response);
             return
        }
        
        dispatch(lastStep())
    }

    const sendTest= async()=>{
        setError('')
        let answerTrueCount = 0
        for(let i in test){
            if(answers[i]===null){
                setError('Требуется дать ответы на все вопросы')
                return;
            }
            if(test[i].answers[Number(answers[i])].isTrue){
                answerTrueCount++;
            }
        }
        
        if(answerTrueCount === test.length && maxActiveLessonId<lessons.length){
           await setLastStep()
        }

        nav('/testresult')
        
    }

    return ( 
        <div className={classes.education}>
            <FullSpaseLoader isLoader={isLoader} />
            <div className={classes.container}>          
                <div className={classes.lessonContainer}>
                    <div className={classes.title}>
                        Итоговое тестирование
                    </div>
                    <div className={classes.questions}>
                        {
                            test.map((item)=>{
                                return(
                                    <Question key={'q'+item.id} item={item as ITest} setValue={setValue} answer={answers[item.id]}/>
                                )
                            })
                        }
                        
                    </div>
                    <div className={classes.error}>
                        {error}
                    </div>
                    <div className={classes.buttons}>
                        <Button2 onClick={()=>nav('/education')}>Отменить тестирование</Button2>
                        <Button1 onClick={()=>sendTest()}>Отправить на проверку</Button1>
                    </div>
                    <div style={{minHeight:"100px", width:'100%'}} />
                    
                </div>
                
            </div>
            
        </div>
     );
}
 
export default Test;